export default __webpack_public_path__ + "static/space-instructions-dark-dd21d31d1ab20f121e68be674f7282a5.png";